import { environment } from "@local/environments/environment";

import { ComponentZooModule } from "./component-zoo";
import { GoLoginModule } from "./go-login";
import { NoPermissionModule } from "./no-permission";
import { NotFoundModule } from "./not-found";
import { TestPageModule } from "./test-page";

const pages: any[] = [GoLoginModule, NoPermissionModule, NotFoundModule];

if (!environment.production) {
  pages.unshift(TestPageModule, ComponentZooModule);
}

export { pages };

export * from "./routes";
